/*
  Debounce function
 */

export default function (fn, wait, ctx = this) {
  let delay = null;
  let args = null;

  const later = () => fn.apply(ctx, args);

  return function () {
    args = arguments;
    clearTimeout(delay);
    delay = setTimeout(later, wait);
  };
}
